import { useRef, useState, useCallback, useEffect } from 'react';
import { connect } from 'react-redux';

import CloseIcon from '../icons/closeIcon';
import BackIcon from '../icons/backIcon';

const PopupWindow = ({ children, title, closeDialogue, bgStyle, onBackButton, isFullHeight, contentPaddingStyle, footer }) => {
  const backdropRef = useRef(null);
  const mouseDownOnBackdrop = useRef(false);
  const isTouchDevice = useRef(false);

  // Close the dialog when escape is pressed
  useEffect(() => {
    const onKeyUp = (event) => {
      if(event.key === 'Escape') { 
        try { closeDialogue(); } catch(error) {}
      }
    };

    window.addEventListener('keyup', onKeyUp);
    return () => { window.removeEventListener('keyup', onKeyUp); }; // remove listener when component unloads
  }, [closeDialogue]);

  return (
    <div 
      ref={backdropRef}  
      className={`fixed top-0 left-0 h-screen w-screen flex justify-center items-center bg-[#000000aa] ${typeof closeDialogue === 'function' ? 'cursor-pointer' : ''}`}
      onTouchStart = {(event) => {
        // detect touches devices with this event
        isTouchDevice.current = true;
      }}
      onMouseDown = {(event) => {
        // using mousedown/mouseup to trigger closing the window by clicking backdrop ref because it works better than onclick
        // we can ensure both mouseup and mousedown events occured on the backdrop ref before closing the popup
        if(event.target !== backdropRef.current) return;
        mouseDownOnBackdrop.current = true;
      }}
      onMouseUp = {(event) => {
        if(event.target !== backdropRef.current) return;
        if(!mouseDownOnBackdrop.current) return;
        mouseDownOnBackdrop.current = false;
        try { closeDialogue(); } catch(error) {}
      }}
      onClick={(event) => {
        if(event.target !== backdropRef.current) return;
        if(!isTouchDevice.current) return; // only using this method of closing the popup for touch devices
        try { closeDialogue(); } catch(error) {}
      }}
    >
      <div className={`relative flex flex-col mx-0.5 lg:max-w-[95vw] max-h-[94vh] ${isFullHeight ? 'min-h-[94vh]' : ''} ${bgStyle || 'bg-white'} rounded-2xl border border-[#222] cursor-default overflow-hidden animate-up-fade`}>
        {/* header */}
        <div className={`relative flex justify-between items-center text-white px-[18px] mt-1.5 mb-3`}>
          <div className='flex justify-center items-center gap-x-1.5 grow'>
            {typeof title === 'function' ? title() : ((typeof title === 'string' && title.length > 0) ? <p className={`text-[1.8em] font-semibold text-white tracking-tight`}>{title}</p> : <></>)}
          </div>
          {/* Close button */}
          {typeof closeDialogue === 'function' &&
            <button 
              className='absolute top-1.5 right-[14px] flex cursor-pointer items-center' 
              onClick={() => { 
                try { closeDialogue(); } catch(error) {}
              }}
            >
              <CloseIcon hoverColor='#fff' />
            </button>
          }
          {/* Back button */}
          {typeof onBackButton === 'function' && 
            <button 
              className='group absolute top-2 left-[14px] flex cursor-pointer items-center' 
              title='Go Back'
              onClick={() => { 
                try { onBackButton(); } catch(error) {}
              }}
            >
              <div className='group-hover:hidden'><BackIcon color='#a59e9e' /></div>
              <div className='hidden group-hover:block'><BackIcon color='#fff' /></div>
            </button>
          }
        </div>
        <div className={`grow flex flex-col ${contentPaddingStyle || 'pl-4 pr-4 pb-4'} overflow-y-auto overflow-x-hidden`}>
          {children}
        </div>
        {typeof footer === 'function' && footer()}
      </div>
    </div>
  );
};

// define redux state that will be passed in as props
const mapStateToProps = state => { return {}};
export default connect(mapStateToProps, {})(PopupWindow);
